// extracted by mini-css-extract-plugin
module.exports = {"viewCandidate":"_39IHx80D","viewCandidateModal":"r1tyTADy","scrollDiv":"_3gO4xX7U","contentContainer":"_2KFF0nOH","player":"CxTLW_sw","modal":"_2UbAefd8","theaterContainer":"_2sfrwV05","closeTheater":"fzytOIOk"};
    if(module.hot) {
      // 1754514959055
      var cssReload = require("!../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  